import { Gender } from '../enums/gender.enum';
import { Serializable } from '../interfaces/serializable';
import { SecretAnswer } from './secret-answer.model';

export class User implements Serializable {

    private _uuid: string = null;
    public username: string = "";
    public firstName: string = "";
    public lastName: string = "";
    public fullName: string = "";
    public email: string = null;
    public phone: string = null;
    public birthDate: Date = null;
    public gender: Gender = Gender.MALE;
    public secretAnswers: SecretAnswer[] = [];
    public createdAt: Date = null;
    public updatedAt: Date = null;

    constructor() { }

    public getId(): string {
        return this._uuid;
    }

    public getIRI(): string {
        return '/api/users/' + this.getId();
    }

    public getFullName(): string {
        return this.firstName + ' ' + this.lastName.toUpperCase();
    }

    public update(data: any = {}): this {
        if (!data) {
            return null;
        }

        const properties = Object.getOwnPropertyNames(this);
        Object.keys(data).forEach((key) => {
            switch (key) {
                case '_uuid': break;                
                default:
                    if (properties.includes(key)) {
                        this[key] = data[key];
                    }
                    break;
            }
        });

        return this;
    }

    public deserialize(input: any = {}): this {
        if (!input) {
            return null;
        }

        const properties = Object.getOwnPropertyNames(this);
        Object.keys(input).forEach((key) => {
            if (input[key] !== null) {
                switch (key) {
                    case 'uuid':
                        this._uuid = input[key];
                        break;    
                    case 'createdAt':
                    case 'updatedAt':
                    case 'birthDate':
                        this[key] = new Date(input[key]);
                        break;                                    
                    default:
                        if (properties.includes(key)) {
                            this[key] = input[key];
                        }
                        break;
                }
            }
        });

        return this;
    }

    public serialize(): any {
        var output = {};

        Object.getOwnPropertyNames(this).forEach(property => {
            switch (property) {
                case '_uuid':
                    if (this[property]) {
                        output['uuid'] = this[property];
                    }
                    break;                
                default:
                    output[property] = this[property];
                    break;
            }
        });

        return output;
    }
}
